import { getApiBaseUrl } from '@/config/environment';


export interface ToggleVehicleActiveRequest {
  is_active: boolean;
  reason?: string;
}

export interface ToggleVehicleActiveResponse {
  success: boolean;
  message?: string;
  data?: {
    vehicleId: string;
    status: string;
    isActive: boolean;
    previousState: boolean;
    updatedAt: string;
    vehicle: {
      make: string;
      model: string;
      year: string;
    };
  };
  error?: {
    code: string;
    message: string;
  };
}

/**
 * Toggle vehicle active/inactive status
 * PUT /api/v1/admin/vehicles/[vehicleId]/toggle-active
 */
export async function toggleVehicleActive(
  vehicleId: string,
  data: ToggleVehicleActiveRequest
): Promise<ToggleVehicleActiveResponse> {
  try {
    const response = await fetch(
      `${getApiBaseUrl()}/api/v1/admin/vehicles/${vehicleId}/toggle-active`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(data),
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error?.message || 'Failed to toggle vehicle status');
    }

    return result;
  } catch (error) {
    console.error('Error toggling vehicle status:', error);
    throw error;
  }
}

export interface UpdateVehiclePricingRequest {
  dailyRate?: number;
  halfDayRate?: number;
  fuelPrice?: number;
}

export interface UpdateVehiclePricingResponse {
  success: boolean;
  data?: {
    vehicleId: string;
    dailyRate?: number;
    halfDayRate?: number;
    fuelPrice?: number;
    updated_at: string;
  };
  error?: {
    code: string;
    message: string;
  };
}

/**
 * Update vehicle pricing (daily rate, half-day rate, fuel price)
 * PATCH /api/v1/admin/vehicles/[vehicleId]/pricing
 */
export async function updateVehiclePricing(
  vehicleId: string,
  data: UpdateVehiclePricingRequest
): Promise<UpdateVehiclePricingResponse> {
  try {
    const response = await fetch(
      `${getApiBaseUrl()}/api/v1/admin/vehicles/${vehicleId}/pricing`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(data),
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error?.message || 'Failed to update vehicle pricing');
    }

    return result;
  } catch (error) {
    console.error('Error updating vehicle pricing:', error);
    throw error;
  }
}
